import { Markdownish } from "./markdown";
import { MessageSquare } from "lucide-react";

/**
 * Paragraph-form interpretation of where the business sits versus peers
 * across profitability, leverage, and working-capital. Sits BELOW the
 * existing colored-dot Benchmark card — the dots show position, this card
 * tells the *meaning* of that position.
 */
export default function BenchmarkCommentaryCard({ commentary, industryLabel }) {
  if (!commentary) return null;
  return (
    <div className="mb-6" data-testid="benchmark-commentary-card">
      <div className="bg-white border border-[#E5E0D8] rounded-2xl p-6 sm:p-8">
        <div className="flex items-center gap-2.5 mb-3">
          <MessageSquare size={14} strokeWidth={1.5} className="text-[#5C665D]" />
          <p className="text-[10px] uppercase tracking-[0.22em] text-[#5C665D] font-medium">
            Peer commentary · {industryLabel}
          </p>
        </div>
        <p className="font-serif-display text-xl sm:text-2xl text-[#1F382E] tracking-tight leading-tight mb-4">
          What the peer data above actually means for you.
        </p>
        <div
          className="max-w-3xl [&_p]:text-[14px] [&_p]:leading-[1.7] [&_p]:text-[#1A1A1A] [&_p]:mb-3 [&_strong]:text-[#1F382E] [&_strong]:font-medium"
          data-testid="benchmark-commentary-body"
        >
          <Markdownish text={commentary} />
        </div>
      </div>
    </div>
  );
}
